import { IMenuItem } from '../types';

export function handleTabOrEscapeToLeaveSubmenu(keyboardEventKey: string, anchorEl: HTMLElement | null) {
  if (['Tab', 'Escape'].includes(keyboardEventKey)) {
    // If 'Tab' or 'Escape' is pressed, focus is moved to the anchor element
    // For case of 'Tab', default browser behavior will take it to next focusable element
    // For case of 'Escape', default browser behavior will close the submenu
    anchorEl?.focus();
  }
}

export function handleArrowDownToMoveFocus(keyboardEventKey: string, elementToFocusOn: HTMLElement | null) {
  if (keyboardEventKey === 'ArrowDown' && elementToFocusOn) {
    elementToFocusOn.focus();
  }
}

export const handleSubmenuItemKeyDown = (
  e: React.KeyboardEvent,
  innerItemsAreFocusable: () => boolean,
  item: Pick<IMenuItem, 'url' | 'onClick'>,
  labelRef?: React.RefObject<HTMLDivElement>
) => {
  const key = e.key;
  const currentTarget = e.currentTarget as HTMLElement;

  if (currentTarget?.querySelector(':focus')) {
    // If there's an inner item focused,
    // focus back on parent and let default up/down behavior happen
    if (['ArrowUp', 'ArrowDown'].includes(key)) {
      currentTarget.focus();
    }
  } else if (['Enter', ' '].includes(key)) {
    if (innerItemsAreFocusable()) {
      labelRef.current?.focus();
    } else if ((item.url || item.onClick) && labelRef?.current) {
      // If item has a URL or onClick, click inner Link/button component
      // (important for keyboard navigation & general accessibility)
      labelRef.current.click();
    }
  }
};

export function focusElementOnShiftTabKeydown(
  e: KeyboardEvent,
  keydownHappenedInContainer: boolean,
  elementToFocusOn: HTMLElement | null
) {
  if (e.key === 'Tab' && e.shiftKey && keydownHappenedInContainer) {
    e.preventDefault();
    elementToFocusOn?.focus();
  }
}

export function focusElementOnEscapeKeydown(e, elementToFocusOn) {
  if (e.key === 'Escape') {
    elementToFocusOn?.focus();
  }
}
